import styled from 'styled-components';

interface EditorCustomStyledProps {
  disabledEditor?: boolean;
}
export const EditorCustomStyled = styled.div<EditorCustomStyledProps>`
  * .rsw-btn {
    cursor: ${(props) => (props.disabledEditor ? 'not-allowed' : 'auto')};
    pointer-events: ${(props) => (props.disabledEditor ? 'none' : 'auto')};
  }
`;
